/**
 * @generated SignedSource<<d391254ac0c51d7c2e6c738fcea77f90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type WarrantyStatusEnum = "ACTIVE" | "EXPIRED" | "INIT" | "PENDING" | "%future added value";
export type WarrantyCellSubscription$variables = {
  customerId?: string | null | undefined;
};
export type WarrantyCellSubscription$data = {
  readonly warrantyUpdated: {
    readonly commencementDate: any | null | undefined;
    readonly id: string;
    readonly status: WarrantyStatusEnum;
  } | null | undefined;
};
export type WarrantyCellSubscription = {
  response: WarrantyCellSubscription$data;
  variables: WarrantyCellSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customerId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "customerId",
        "variableName": "customerId"
      }
    ],
    "concreteType": "Warranty",
    "kind": "LinkedField",
    "name": "warrantyUpdated",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "commencementDate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WarrantyCellSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WarrantyCellSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1be3dadfd5c448b2bbf4f63f64b8be0c",
    "id": null,
    "metadata": {},
    "name": "WarrantyCellSubscription",
    "operationKind": "subscription",
    "text": "subscription WarrantyCellSubscription(\n  $customerId: ID\n) {\n  warrantyUpdated(customerId: $customerId) {\n    id\n    status\n    commencementDate\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed06d008724993b6331b61738bbe6d93";

export default node;
